module.exports = __webpack_public_path__ + "static/media/successTransaction.336c89d7.svg";